import { createTheme } from '@ibe/components';
import './Styles/IBE.scss';
import { customTheme } from './customTheme';

const theme = createTheme(customTheme);

export default theme;
